import { Injectable } from '@angular/core'
import { WebService } from '../api/web.service'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/store/state/app.state'
import { ServiceUrlConstants } from 'src/app/constants/service-url-constants'
import { Observable, map } from 'rxjs'
import { CalendarEventAPIModel, PaginatedAPI } from 'src/app/models/api.model'
import {
  fetch_calendar_details,
  save_calendar_action,
  update_calendar_action
} from 'src/app/store/action/calendar.action'
import { getCalendarDetails } from 'src/app/store/selector/calendar.selector'

@Injectable({
  providedIn: 'root'
})
export class CalendarService {
  constructor(private webservice: WebService, private appState: Store<AppState>) {}

  invokeCalendarSummaryAPI = (queryParams: { key: string; value: string }[], searchRequestBody) => {
    return this.webservice
      .post(ServiceUrlConstants.API_CALENDAR_LIST, searchRequestBody, null, queryParams)
      .pipe(map((data: PaginatedAPI<CalendarEventAPIModel>) => data))
  }

  dispatchFetchCalendarDetailsAction(id: CalendarEventAPIModel) {
    return this.appState.dispatch(fetch_calendar_details({ id }))
  }

  dispatchSaveCalendartAction(calendar: CalendarEventAPIModel, files: File[], routeTo: string) {
    this.appState.dispatch(save_calendar_action({ calendar, files, routeTo }))
  }

  dispatchCalendarAction(id: CalendarEventAPIModel, calendar: CalendarEventAPIModel, files: File[], routeTo: string) {
    this.appState.dispatch(update_calendar_action({ id, calendar, files, routeTo }))
  }

  getCalendarDetailsFromStore = (): Observable<CalendarEventAPIModel> => {
    return this.appState.select(getCalendarDetails())
  }

  callSaveApi = (calendar: CalendarEventAPIModel, files: File[]) => {
    const formData: FormData = new FormData()
    const calendarEvent = new Blob([JSON.stringify(calendar)], { type: 'application/json' })
    formData.append('calendarEvent', calendarEvent)

    if (files) {
      for (let i = 0; i < files.length; i++) {
        formData.append('documentList', files[i])
      }
    }

    const endPoint = ServiceUrlConstants.API_CALENDAR_SAVE_UPDATE
    return this.webservice.post(endPoint, formData, null, [], false).pipe(map((data: CalendarEventAPIModel) => data))
  }

  callUpdateApi = (id: CalendarEventAPIModel, calendar: CalendarEventAPIModel, files: File[]) => {
    const endPoint = `${ServiceUrlConstants.API_CALENDAR_SAVE_UPDATE}/${id}`

    const formData: FormData = new FormData()
    const calendarEvent = new Blob([JSON.stringify(calendar)], { type: 'application/json' })
    formData.append('calendarEvent', calendarEvent)

    if (files) {
      for (let i = 0; i < files.length; i++) {
        formData.append('documentList', files[i])
      }
    }
    return this.webservice.put(endPoint, formData, null, [], false).pipe(map((data: CalendarEventAPIModel) => data))
  }

  callCalendarDetailsApi(id: CalendarEventAPIModel) {
    const endPoint = `${ServiceUrlConstants.API_CALENDAR_SAVE_UPDATE}/${id}`
    return this.webservice.get(endPoint).pipe(map((data: CalendarEventAPIModel) => data))
  }

  invokeSaveBulkCalendarAPI(rowsToSave: CalendarEventAPIModel[], documentToSave: File): Observable<any> {
    const endPoint = ServiceUrlConstants.API_SAVE_BULK_CALENDAR_EVENT
    const formData: FormData = new FormData()
    const calendarBlob = new Blob([JSON.stringify(rowsToSave)], { type: 'application/json' })
    formData.append('calendarEvents', calendarBlob)

    if (documentToSave) {
      formData.append('documents', documentToSave)
    }

    return this.webservice.post(endPoint, formData, null, [], false)
  }
}
